/**
 * State central consolidado (Bloco 6).
 * Agrega visitor, session, currentPageView, behaviorState e queueState em um único getter.
 */

import type { Visitor, CoreSession, PageViewRecord } from './types';
import type { BehaviorState } from './behavior/types';
import {
  getVisitor,
  getSession,
  getPageViewState,
  getQueueStats,
  type QueueStats,
} from './core';
import { getBehaviorState } from './behavior';

export interface TrackerState {
  visitor: Visitor | null;
  session: CoreSession | null;
  currentPageView: PageViewRecord | null;
  behaviorState: BehaviorState | null;
  queueState: QueueStats;
}

/**
 * Retorna o estado consolidado do tracker (visitor, session, pageView, behavior, queue).
 * Útil para debug e integrações.
 */
export function getTrackerState(): TrackerState {
  const visitor = getVisitor();
  const session = getSession();
  const pageState = getPageViewState();
  const currentPageView: PageViewRecord | null = pageState
    ? {
        url: pageState.url,
        path: pageState.path,
        title: pageState.title,
        referrer: pageState.referrer,
        maxScrollPercent: pageState.maxScrollPercent,
        timestamp: pageState.startedAt ?? Date.now(),
      }
    : null;
  let behaviorState: BehaviorState | null = null;
  try {
    behaviorState = getBehaviorState();
  } catch {
    // behavior não inicializado
  }
  const queueState = getQueueStats();
  return {
    visitor: visitor ?? null,
    session: session ?? null,
    currentPageView,
    behaviorState,
    queueState,
  };
}
